import { render, staticRenderFns } from "./ClinicianRespondent.vue?vue&type=template&id=555da910"
import script from "./ClinicianRespondent.vue?vue&type=script&lang=js"
export * from "./ClinicianRespondent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports